module.exports = __webpack_public_path__ + "static/media/paymentmethods.c0473139.svg";